/** `/c/$companyId/banking/movements/new?kind&account&copy` — a new movement, created on its first save. */
import type { JSX } from "react";
import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { MOVEMENT_KINDS } from "../api/codes";
import { ComposeScreen } from "../banking/movement/ComposeScreen";
import { CODE_SETS } from "../ledger/books";
import { CodeGate } from "../shell/CodeGate";

const search = z.object({
  kind: z.enum(MOVEMENT_KINDS).optional().catch(undefined),
  /** The account the money leaves or reaches. */
  account: z.string().uuid().optional().catch(undefined),
  /** The movement this one starts as a copy of. */
  copy: z.string().uuid().optional().catch(undefined),
});

export const Route = createFileRoute("/_auth/c/$companyId/banking/movements/new")({
  validateSearch: (raw) => search.parse(raw),
  component: NewMovementRoute,
});

function NewMovementRoute(): JSX.Element {
  const { companyId } = Route.useParams();
  const { kind, account, copy } = Route.useSearch();
  return (
    <CodeGate companyId={companyId} codes={CODE_SETS.PREP}>
      <ComposeScreen companyId={companyId} kind={kind} account={account} copy={copy} />
    </CodeGate>
  );
}
